"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const MenuIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ width: "40", height: "40", viewBox: "0 0 40 40", fill: "none" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M13 24H27", stroke: color !== null && color !== void 0 ? color : theme.colors.grey90, strokeWidth: "2", strokeLinecap: "round" }), (0, jsx_runtime_1.jsx)("path", { d: "M13 20H27", stroke: color !== null && color !== void 0 ? color : theme.colors.grey90, strokeWidth: "2", strokeLinecap: "round" }), (0, jsx_runtime_1.jsx)("path", { d: "M13 16H27", stroke: color !== null && color !== void 0 ? color : theme.colors.grey90, strokeWidth: "2", strokeLinecap: "round" })] })));
};
exports.MenuIcon = MenuIcon;
//# sourceMappingURL=menu_icon.js.map